import { useQuery } from '@tanstack/vue-query'
import { computed, type ModelRef } from 'vue'
import { useHelpers, useHttp } from '@/shared/lib'

export const useGetSearchObjects = (search: any, object_type = 0) => {
  const http = useHttp()
  const { generateKey } = useHelpers()

  return useQuery({
    queryKey: [generateKey()],
    queryFn: () => http.get(`/objects/search?query=${search.value}&object_type=${object_type}`),
    retry: false,
    enabled: false,
  })
}

export const useGetSearchObject = (id: ModelRef<any>) => {
  const http = useHttp()
  const { generateKey } = useHelpers()
  const enabled = computed(() => id.value > 0)

  return useQuery({
    queryKey: [generateKey()],
    queryFn: () => http.get(`/objects/${id.value}/search`),
    retry: false,
    enabled,
  })
}
